module.exports = "<hot-table [minSpareRows]=\"0\" [height]=\"600\" [manualColumnResize]=\"true\" [autoColumnSize]=\"true\" [startRows]=\"35\" [height]=\"600\" [rowHeaders]=\"rowHeaders\" [columns]=\"columns\" [data]=\"data\" hotId=\"SummaryRemarks\">\n</hot-table>"


//////////////////
// WEBPACK FOOTER
// ./src/app/summary-remarks/summary-remarks.component.html
// module id = ./src/app/summary-remarks/summary-remarks.component.html
// module chunks = main